import { Styles } from '../../theme/materialTheme';

export const message: Styles = (theme) => ({
  color: theme.palette.error.main,
  position: 'absolute',
});
